
import { Component, Vue, Prop } from 'vue-property-decorator'
import { format } from 'timeago.js'
import {
  INotification,
  NotificationStatus
} from '@/modules/in-app-notification/types/notificationTypes'

@Component({
  name: 'NotificationCard'
})
export default class NotificationCard extends Vue {
  @Prop({ type: Object, required: true })
  readonly notification!: INotification

  @Prop({ type: Boolean, default: true })
  readonly textClamped!: boolean

  // Make format and NotificationStatus available in template
  format = format
  NotificationStatus = NotificationStatus

  handleClick(): void {
    this.$emit('click', this.notification)
  }

  async handleExternalLinkClick() {
    this.$emit('external-link-clicked', this.notification)
  }
}
